<script setup lang="ts">
import type { StrapiBlockRendererProps, StrapiBlockType } from '@nimbus/types'
import type { defineAsyncComponent } from '#imports'
import {
    LazyNimbusStrapiBlockText,
    LazyNimbusStrapiBlockLink,
    LazyNimbusStrapiBlockList,
    LazyNimbusStrapiBlockListItem,
    LazyNimbusStrapiBlockHeading,
    LazyNimbusStrapiBlockParagraph,
    LazyNimbusStrapiBlockCode
} from '#components'

const props = defineProps<StrapiBlockRendererProps>()

const COMPONENTS: Record<StrapiBlockType, ReturnType<typeof defineAsyncComponent>> = {
    'text': LazyNimbusStrapiBlockText,
    'link': LazyNimbusStrapiBlockLink,
    'list': LazyNimbusStrapiBlockList,
    'list-item': LazyNimbusStrapiBlockListItem,
    'heading': LazyNimbusStrapiBlockHeading,
    'paragraph': LazyNimbusStrapiBlockParagraph,
    'code': LazyNimbusStrapiBlockCode,
}

// Components that support the newTabLinks prop
const SUPPORTS_NEW_TAB_LINKS = ['link', 'paragraph', 'code']
</script>

<template>
    <template v-for="(child, childIndex) in props.content" :key="childIndex">
        <component
            :is="COMPONENTS[child.type]"
            v-bind="{
                ...child,
                ...(SUPPORTS_NEW_TAB_LINKS.includes(child.type) ? { newTabLinks: props?.newTabLinks } : {})
            }"
        />
    </template>
</template>
